const storagePrefix = 'movie_cra_';

const storage = {
  getToken: () => {
    return window.localStorage.getItem(`${storagePrefix}token`);
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, token);
  },
  clearToken: () => {
    // window.localStorage.removeItem(`${storagePrefix}token`);
    window.localStorage.clear();
  },
};

export default storage;
